import { Component, OnInit } from '@angular/core'
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { ActivatedRoute } from '@angular/router'
import { Router } from '@angular/router'

@Component({
  selector: 'app-incoming-call',
  templateUrl: './incoming-call.component.html',
  styleUrls: ['./incoming-call.component.scss']
})
export class IncomingCallComponent implements OnInit {
  cookieData: any
  telephoneNo: any
  idCard: any

  isCrisis = true
  contactDros: any
  contactDa: any

  constructor(
    private apiService: ApiService,
    private util: UtilService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  async ngOnInit() {
    this.util.ShowWaiting(true)
    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.isCrisis = this.cookieData.isCrisis

    this.activatedRoute.queryParams.subscribe(params => {
      this.telephoneNo = params['phoneNo'];
      this.idCard = params['idCard'];
    });

    if ((this.telephoneNo == null || this.telephoneNo.toString().trim().length == 0) &&
      (this.idCard == null || this.idCard.toString().trim().length == 0)) {
      this.util.ErrorDialog("กรุณาระบุข้อมูล phoneNo หรือ idCard")
      return
    }

    let para = ""
    if (this.telephoneNo != null && this.telephoneNo.trim().length > 0) {
      para += para.length > 0 ? "&telephoneno=" + this.telephoneNo : "telephoneno=" + this.telephoneNo
    }

    if (this.idCard != null && this.idCard.trim().length > 0) {
      para += para.length > 0 ? "&idcard=" + this.idCard : "idcard=" + this.idCard
    }


    let contact: any = await this.apiService.get("crmservice", "contact", para)
    this.util.ShowWaiting(false)
    
    if (contact == null || contact.length == 0) {//ไม่พบข้อมูลที่ CRM

      if (this.isCrisis) {//วิกฤต

        await this.getDrosContact()
        await this.getDAContact()

        if (this.contactDros != null && this.contactDros.CRM06 != null && this.contactDros.CRM06.Name != null) {//ไม่เจอ
          //create crm contact ด้วยข้อมูลจาก DROS

          let name: string = this.contactDros.CRM06.Name.split(" ")
          let firstname = ""
          let lastname = ""
          let phoneNo =  ""  
          if(name.length > 0){
            if(name.length == 1){
              firstname = name[0]
            }
            else if(name.length == 2){
              firstname = name[0]
              lastname = name[1]
            }
            else if (name.length > 2){ 
              for(let i = 0; i < name.length -1; i++){
                firstname += " " + name[i]
              }
              firstname = firstname.trim()
              lastname = name[name.length -1]
            }
          }

          if(this.telephoneNo != null && this.telephoneNo.trim().length > 0) 
          { 
              phoneNo =this.telephoneNo
          }
          else
          {
            phoneNo = this.contactDros.CRM06.PhoneNo
          }

          let req: any = {
            createdon: new Date().toISOString(),
            modifiedon: new Date().toISOString(),
            firstname: firstname,
            lastname: lastname,
            dpa_idcard: this.contactDros.CRM06.IDNo,
            dpa_authorizedperson_idcard: this.contactDros.CRM06.IDNo,
            dpa_authorizedperson_telephone: phoneNo,
            telephone1: phoneNo,
            emailaddress1: this.contactDros.CRM06.Email,
            statusreason: 1,
            //callcenterflag: true
          }

          await this.apiService.post("crmservice", "contact", req).then(async (res: any) => {
            if (this.util.isSuccessResponse(res)) {
              if (res.contactid != null && res.contactid != "") {
                //new tab customer4tab (2)
                this.router.navigate(["/customer/" + res.contactid])
              }
              else {
                this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ")
              }
            }
            else {
              this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ")
            }
          })
        }
        else if (this.contactDa != null && this.contactDa.FirstName.trim().length > 0 )
        {
          let phone: string = this.contactDa.MobileNumber.split(",")
          let firstname = this.contactDa.FirstName
          let lastname = this.contactDa.LastName
          let phoneNo =  ""   

          if(this.telephoneNo != null && this.telephoneNo.trim().length > 0) 
          { 
            phoneNo =this.telephoneNo
          } 
          else
          {
            if (phone.length > 0 && phone[0] != "N/A")
            {
              phoneNo = phone[0]
            }
            else
            {
              phoneNo =this.telephoneNo
            }

          }

          let req: any = {
            createdon: new Date().toISOString(),
            modifiedon: new Date().toISOString(),
            firstname: firstname,
            lastname: lastname,
            dpa_idcard: this.contactDa.IdentityNumber,
            dpa_authorizedperson_idcard: this.contactDa.IdentityNumber,
            dpa_authorizedperson_telephone: phoneNo,
            telephone1: phoneNo,
            emailaddress1: this.contactDa.EmailAddress,
            statusreason: 1,
            //callcenterflag: true
          }

          await this.apiService.post("crmservice", "contact", req).then(async (res: any) => {
            if (this.util.isSuccessResponse(res)) {
              if (res.contactid != null && res.contactid != "") {
                //new tab customer4tab (2)
                this.router.navigate(["/customer/" + res.contactid])
              }
              else {
                this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ")
              }
            }
            else {
              this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ")
            }
          })

        }
        else {
          // this.cookieData.incomingTelephoneNo = this.telephoneNo
          // this.cookieData.incomingIdCard = this.idCard
          // localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))

          //หน้าจอค้นหา Contact(1)
          if (this.idCard != null && this.idCard.trim().length > 0) {
            this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo, idCard: this.idCard } });
          }
          else {
            this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo } });
          }
        }
      }
      else {
        this.cookieData.incomingTelephoneNo = this.telephoneNo
        this.cookieData.incomingIdCard = this.idCard
        localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))

        this.router.navigate(["/newContact"])
      }
    }
    else if (contact.length == 1) {//เจอที่ CRM 1 record
      if(this.isCrisis){
        await this.getDrosContact()
        if (this.contactDros != null || this.contactDros.CRM06 != null) {//ไม่เจอ

          //หน้าจอค้นหา Contact(1)
          if (this.idCard != null && this.idCard.trim().length > 0) {
            this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo, idCard: this.idCard } });
          }
          else {
            this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo } });
          }
        }
        else{
          //Customer4Tab (2)
          this.router.navigate(["/customer/" + contact[0].contactid])
        }
      }
      else{
        this.router.navigate(["/customer/" + contact[0].contactid])
      }
    }
    else { //contact.length > 1
      if (this.idCard != null && this.idCard.trim().length > 0) {
        this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo, idCard: this.idCard } });
      }
      else {
        this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo } });
      }
    }
  }

  async getDrosContact(){
    let para = "CRM06=true"
    if (this.idCard != null && this.idCard.toString().trim().length > 0) {
      para += "&dpa_id=" + this.idCard
    }
    if (this.telephoneNo != null && this.telephoneNo.toString().trim().length > 0) {
      para += "&telephoneno=" + this.telephoneNo
    }
    this.contactDros =  await this.apiService.get("crmservice", "contactDros", para)//ค้น DROS
  }

  async getDAContact(){
    let para = ""
    if (this.idCard != null && this.idCard.toString().trim().length > 0) {
      para += "IdNo=" + this.idCard
    } 
    this.contactDa =  await this.apiService.get("crmservice", "getDA", para)//ค้น DA
  }
}



// WEBPACK FOOTER //
// ./src/app/incoming-call/incoming-call.component.ts